import TranslationalObject from '@/models/TranslationalObject';

export default class TranslationRepository {
    public static getFirst() {
        return TranslationalObject.query().first();
    }
}
